import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MapPinIcon } from '@heroicons/react/20/solid';

import { useCommunityMembership } from '../../../_hooks/useCommunityMembership';
import type { Space } from '../../../_hooks/useSpace';
import { useSpaceAccess } from '../../../_hooks/useSpaceAccess';

export const CityChannelReason: FC<{ space: Space }> = ({ space }) => {
  const { t } = useTranslation();
  const { currentMember } = useCommunityMembership();
  const { isSpacePlaced } = useSpaceAccess();
  const { city } = space;
  if (!city) return null;

  const reason = () => {
    if (isSpacePlaced(space)) return t('community.space.city_near', { city: currentMember?.city ?? city.name });
    if (space.joined) return t('community.space.city_joined');

    return t('community.space.city_within', { radius: city.radius_miles, city: city.name });
  };

  return (
    <p className="flex items-center justify-center gap-1 text-sm leading-5 text-black/60">
      <MapPinIcon className="size-4 shrink-0" aria-hidden="true" />
      {reason()}
    </p>
  );
};
